var React = require('react');

function WorkCase (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"currentColor","d":"M10.5 4.5V3h-3v1.5h3zM3 6v8.25h12V6H3zm12-1.5c.832 0 1.5.668 1.5 1.5v8.25c0 .832-.668 1.5-1.5 1.5H3c-.833 0-1.5-.668-1.5-1.5L1.508 6c0-.832.66-1.5 1.492-1.5h3V3c0-.833.668-1.5 1.5-1.5h3c.832 0 1.5.667 1.5 1.5v1.5h3z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H18V18H0z","key":1})]));
}

WorkCase.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = WorkCase;

WorkCase.default = WorkCase;
